import { useEffect, useState } from "react";
import UserService from "../services/user.service";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/system';
import CommonDocuments from "./_commonDocuments";
import CommonVideos from "./_commonVideos";

const Anleitungen = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    async function fetchCurrentUser() {
      try {
        const user = await UserService.getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        console.error("Error fetching current user:", error);
      }
    }

    fetchCurrentUser();
  }, []);

  if (!currentUser) {
    return null; // You can return a loading indicator or any other fallback UI while waiting for user data
  }

  return (
    <Box sx={{ background: "#F0F2F5", py: 5 }}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={1}>
                  <Box pt={3} pb={3} px={3} sx={{ textAlign: 'left', '@media screen and (min-width: 1200px)': { textAlign: 'center' } }}>
                    <h2>Videos zum Kaufablauf</h2>
                    <CommonVideos grid={4}/>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper elevation={1}>
                  <Box pt={3} pb={3} px={3} sx={{ textAlign: 'left', '@media screen and (min-width: 1200px)': { textAlign: 'center' } }}>
                    <h2>Allgemeine Dokumente</h2>
                    <CommonDocuments />
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Anleitungen;